import api from 'ApiConfig';

const assignmentAttachmentServices = {
  getAttachmentsByAssignment: (assignmentId) =>
    api.get(`/assignment-attachment/${assignmentId}`),
};

export default assignmentAttachmentServices;
